import React, { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import { supabase } from "../../supabase/client";

import { useProcess } from "../../context/ProcessContext";
// import { usePerson } from "../../context/PersonContext";
import { useModalities } from "../../context/ModalitiesContext";
import { useOptionsModalities } from "../../context/OptionsModalitiesContext";

import Select from "../common/Select";
import ButtonPrimaryForm from "../common/ButtonPrimaryForm";
import { IconArrowBottom, IconSave } from "../icons/Icons";
import Input from "../common/Input";
import DataList from "../common/DataList";
import Switch from "../common/Switch";
import Modal from "../common/Modal";

const ProcessForm = ({ idData }) => {
//   const MySwal = withReactContent(Swal);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [classProcesses, setClassProcesses] = useState([]);
  const [typeAmount, setTypeAmount] = useState([]);
  const [resultCourt, setResultCourt] = useState({
    resAdmin: 0,
    resHonorarios: 0,
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [statusProcess, setStatusProcess] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState({
    demanding_id: "",
    defendant_id: "",
  });
  const [selectedSecretary, setSelectedSecretary] = useState({
    secretary_id: "",
  });
  const [secretarios, setSecretarios] = useState([]);
  const [arbitros, setArbitros] = useState([]);
  const [designacionArbitro, setDesignacionArbitro] = useState([]);
  const [selectedDesignacionArbitro, setSelectedDesignacionArbitro] = useState({
    designated_arbitrator_demanding_id: "",
    arbitrator_demanding_id: "",
    designated_arbitrator_defendant_id: "",
    arbitrator_defendant_id: "",
  });
  const [formData, setFormData] = useState({
    class_process_id: 1,
    demanding_id: "",
    defendant_id: "",
    court: false,
    amount: 0,
    arbitration_payments: [
      { title: "", resultado: 0, igv: 0 },
      { title: "", resultado: 0, igv: 0 },
      { title: "", resultado: 0, igv: 0 },
    ],
    summary: "",
    status: false,
  });
  const { getModalities, modalities } = useModalities();
  const { getOptionsModalities, optionsModalities } = useOptionsModalities();
  const { getProcess, getClassProcess, getTypeAmount, createProcess } =
    useProcess();

  const designacionArbitroDemandante = [
    { value: 7, label: "Árbitro designado por el demandante" },
    {
      value: 8,
      label:
        "Árbitro designado por el Consejo en defecto de la designación del demandante",
    },
  ];

  const designacionArbitroDemandado = [
    { value: 9, label: "Árbitro designado por el demandado" },
    {
      value: 10,
      label:
        "Árbitro designado por el Consejo en defecto de la designación del demandado",
    },
  ];

  useEffect(() => {
    getById(idData);
    getPersons();
    getArbitrator();
    getModalities();
    getSecretaries();
    getOptionsModalities();
  }, [idData]);

  useEffect(() => {
    const getStatus = async () => {
      const status = await getStatusProcess();
      setStatusProcess(status);
    };
    getStatus();
  }, []);

  useEffect(() => {
    getDesignacionArbitros();
  }, [formData.court]);

  useEffect(() => {
    const resAdmin = +formData.arbitration_payments[0].resultado;
    const resHonorarios = !formData.court
      ? +formData.arbitration_payments[1].resultado
      : +formData.arbitration_payments[2].resultado;
    setResultCourt({ resAdmin: resAdmin, resHonorarios: resHonorarios });
  }, [formData.arbitration_payments]);

  const getDesignacionArbitros = async () => {
    const type = formData.court ? 2 : 1;
    const { error, data } = await supabase
      .from("court_appointment")
      .select("id, name")
      .eq("type_court", type);
    if (error) console.log(error);
    const designacionData = data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    setDesignacionArbitro(designacionData);
  };

  const getPersons = async () => {
    const { error, data } = await supabase.from("persons").select();
    if (error) throw error.message;
    const personasData = data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    setPersonas(personasData);
  };

  const getSecretaries = async () => {
    const { error, data } = await supabase.from("secretaries").select(`
                users (id, first_name, last_name)
            `);
    if (error) throw error.message;
    const secretariosData = data.map((item) => {
      return {
        value: item.users.id,
        label: item.users.first_name + " " + item.users.last_name,
      };
    });
    setSecretarios(secretariosData);
  };

  const getArbitrator = async () => {
    const { error, data } = await supabase.from("professionals").select();
    if (error) throw error.message;
    const profesData = data.map((item) => {
      return {
        value: item.id,
        label: item.first_name + " " + item.last_name,
      };
    });
    setArbitros(profesData);
  };

  const getById = async (id) => {
    const classProcess = await getClassProcess();
    setClassProcesses(classProcess);
    const typeAmount = await getTypeAmount();
    setTypeAmount(typeAmount);
    if (id !== null) {
      const resp = await getProcess(id);
      setFormData(() => resp);
    }
  };

  const getStatusProcess = async () => {
    const { error, data } = await supabase
      .from("status_process")
      .select("id, name")
      .order("name", { ascending: true });
    if (error) console.log(error);
    return data;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  const handleDataListChange = (e, name) => {
    setFormData(() => ({
      ...formData,
      [name]: e.value,
    }));
    const filterIdPerson = personas.filter((item) => item.value === e.value);
    setSelectedPerson({
      ...selectedPerson,
      [name]: filterIdPerson,
    });
  };
  // console.log(formData)

  const handleInputCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    if (checked) {
      setFormData(() => ({
        ...formData,
        [name]: +value,
      }));
    }
  };

  const handleInputSwitchChange = async (e) => {
    const { name } = e.target;
    setFormData(() => ({
      ...formData,
      [name]: !formData.court,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await createProcess({
      class_arbitration: +formData.class_arbitration,
      class_process_id: +formData.class_process_id,
      amount: +formData.amount,
      date_created: formData.date_created,
      defendant_id: formData.defendant_id,
      demanding_id: formData.demanding_id,
      modalities_id: +formData.modalities_id,
      status: formData.status,
      status_process_id: +formData.status_process_id,
      summary: formData.summary,
      type_arbitration: +formData.type_arbitration,
      type_process_id: +formData.type_process,
      secretary_id: formData.secretary_id,
      court: formData.court,
      // agregar lo demas campos
    });
    // console.log(res)
    // console.log("FORM",formData)
  };

  const handleSelectChange = (e) => {
    const optionValue = e.target.value;
    const optionLabel = optionsModalities.find(
      (option) => +option.id === +optionValue
    ).name;

    if (!selectedOptions.some((option) => option.value === optionValue)) {
      setSelectedOptions([
        ...selectedOptions,
        { value: optionValue, label: optionLabel },
      ]);
      setSelectedValue("");
    }
  };

  const handleDataListCourtChange = (e, name) => {
    // const courts = {
    //     ...formData.court_data,
    // }
    setFormData(() => ({
      ...formData,
      // court_data: courts,
      [name]: e.value,
    }));
    // const filterIdPerson = personas.filter((item) => item.value === e.value)
    // setSelectedPerson({
    //     ...selectedPerson,
    //     [name]: filterIdPerson
    // })
  };

  const handleTagClick = (tagValue) => {
    const updatedOptions = selectedOptions.filter(
      (option) => option.value !== tagValue
    );
    setSelectedOptions(updatedOptions);
  };
  
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-4 mt-4 items-end">
          <div className="flex items-center gap-4">
            {classProcesses.map((item, index) => (
              <label key={index} className="flex gap-1">
                <input
                  type="radio"
                  name="class_process_id"
                  value={item.id}
                  checked={formData.class_process_id === item.id}
                  onChange={handleInputCheckboxChange}
                />
                {item.name}
              </label>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-start">
          <div className="space-y-1">
            <DataList
              textLabel={"Demandante"}
              name={"demanding_id"}
              className="w-3/4"
              required={true}
              value={selectedPerson.demanding_id || ""}
              dataOptions={personas}
              onChange={(e) => handleDataListChange(e, "demanding_id")}
            />
            <DataList
              textLabel={"Demandado"}
              name={"defendant_id"}
              className="w-3/4"
              required={true}
              value={selectedPerson.defendant_id || ""}
              dataOptions={personas}
              onChange={(e) => handleDataListChange(e, "defendant_id")}
            />
            <label className="text-sm font-light flex items-center justify-between gap-1">
              Cuantía
              <div className="flex items-center w-3/4">
                <select className="appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal">
                  <option value="S/">S/</option>
                  <option value="$">$</option>
                  <option value="€">€</option>
                </select>
                <input
                  type="text"
                  name="amount"
                  className="appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal w-full"
                  placeholder="0.00"
                  value={formData.amount}
                  onChange={handleInputChange}
                />
                <div className="relative inline-flex">
                  <select className="appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal">
                    <option value="">Tipo</option>
                    {typeAmount.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <IconArrowBottom className="w-3 h-3 text-gray-400/50 absolute right-2 top-3" />
                </div>
              </div>
            </label>
            <Select
              textLabel={"Tipo de proceso"}
              name={"type_process"}
              className="w-3/4"
              required={true}
              value={formData.type_process}
              dataOptions={[
                { id: 1, name: "Con el estado" },
                { id: 2, name: "Comercial" },
                { id: 3, name: "Otros" },
              ]}
              onChange={handleInputChange}
            />
            <Select
              textLabel={"Tipo de arbitraje"}
              name={"type_arbitration"}
              className="w-3/4"
              required={true}
              value={formData.type_arbitration}
              dataOptions={[
                { id: 1, name: "Nacional" },
                { id: 2, name: "Internacional" },
              ]}
              onChange={handleInputChange}
            />
            <Select
              textLabel={"Clase de arbitraje"}
              name={"class_arbitration"}
              className="w-3/4"
              value={formData.class_arbitration}
              dataOptions={[
                { id: 1, name: "Ad Hoc" },
                { id: 2, name: "Institucional" },
              ]}
              onChange={handleInputChange}
            />
          </div>
          <div className="space-y-1">
            <Select
              textLabel={"Modalidad"}
              name={"modalities_id"}
              className="w-3/4"
              value={formData.modalities_id}
              dataOptions={modalities}
              onChange={handleInputChange}
            />
            <Select
              textLabel={"Opciones modalidad"}
              name={"options_modalities_id"}
              className="w-3/4"
              value={selectedValue}
              dataOptions={optionsModalities}
              onChange={handleSelectChange}
            />
            <div className="w-full h-14">
              {selectedOptions.map((option) => (
                <div
                  key={option.value}
                  className="inline-flex items-center bg-primary text-white text-xs rounded-md p-1 m-1 cursor-pointer"
                  onClick={() => handleTagClick(option.value)}
                >
                  {option.label} <span className="ml-2">×</span>
                </div>
              ))}
            </div>
            <Input
              textLabel={"Fecha de ingreso"}
              typeInput={"date"}
              name={"date_created     "}
              className="w-3/4"
              value={formData.date_created || ""}
              onChange={handleInputChange}
            />
            <Select
              textLabel={"Estado"}
              name={"status_process_id"}
              className="w-3/4"
              value={formData.status_process_id || ""}
              dataOptions={statusProcess}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <h4 className="text-lg text-zinc-600/80 font-normal uppercase mb-1 mt-4">
          Tribunal Árbitral
        </h4>
        <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-start">
          <div className="flex items-center gap-10">
            <h4 className="text-lg text-zinc-600/80 font-normal">
              {formData.court ? "Colegiado" : "Árbitro único"}
            </h4>
            <Switch
              title={"¿Es colegiado?"}
              name={"court"}
              onChange={handleInputSwitchChange}
              checked={formData.court}
              // value={formData.court}
            />
          </div>
          <DataList
            textLabel={"Secretario"}
            name={"secretary_id"}
            className="w-3/4"
            value={selectedSecretary.secretary_id}
            dataOptions={secretarios}
            onChange={(e) => {
              handleDataListChange(e, "secretary_id");
              const filterIdPerson = secretarios.filter(
                (item) => item.value === e.value
              );
              setSelectedSecretary({
                ...selectedSecretary,
                secretary_id: filterIdPerson,
              });
            }}
          />
          <DataList
            textLabel={"Designación / Árbitro"}
            name={"designated_arbitrator_id"}
            className="w-3/4"
            value={selectedDesignacionArbitro.designated_arbitrator_id}
            dataOptions={designacionArbitro}
            onChange={(e) => {
              handleDataListCourtChange(e, "designated_arbitrator_id");
              const filter = designacionArbitro.filter(
                (item) => item.value === e.value
              );
              setSelectedDesignacionArbitro({
                ...selectedDesignacionArbitro,
                designated_arbitrator_id: filter,
              });
            }}
          />
          <DataList
            textLabel={"Presidente"}
            name={"president_id"}
            className="w-3/4"
            value={selectedDesignacionArbitro.president_id}
            dataOptions={arbitros}
            onChange={(e) => {
              handleDataListCourtChange(e, "president_id");
              const filter = arbitros.filter((item) => item.value === e.value);
              setSelectedDesignacionArbitro({
                ...selectedDesignacionArbitro,
                president_id: filter,
              });
            }}
          />
        </div>
        {formData.court && (
          <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-start">
            <DataList
              textLabel={"Designación / Árbitro"}
              name={"designated_arbitrator_demanding_id"}
              className="w-3/4"
              value={
                selectedDesignacionArbitro.designated_arbitrator_demanding_id
              }
              dataOptions={designacionArbitroDemandante}
              onChange={(e) => {
                handleDataListCourtChange(
                  e,
                  "designated_arbitrator_demanding_id"
                );
                const filter = designacionArbitroDemandante.filter(
                  (item) => item.value === e.value
                );
                setSelectedDesignacionArbitro({
                  ...selectedDesignacionArbitro,
                  designated_arbitrator_demanding_id: filter,
                });
              }}
            />
            <DataList
              textLabel={"Árbitro parte demandante"}
              name={"arbitrator_demanding_id"}
              className="w-3/4"
              value={selectedDesignacionArbitro.arbitrator_demanding_id}
              dataOptions={arbitros}
              onChange={(e) => {
                handleDataListCourtChange(e, "arbitrator_demanding_id");
                const filter = arbitros.filter(
                  (item) => item.value === e.value
                );
                setSelectedDesignacionArbitro({
                  ...selectedDesignacionArbitro,
                  arbitrator_demanding_id: filter,
                });
              }}
            />
            <DataList
              textLabel={"Designación / Árbitro"}
              name={"designated_arbitrator_defendant_id"}
              className="w-3/4"
              value={
                selectedDesignacionArbitro.designated_arbitrator_defendant_id
              }
              dataOptions={designacionArbitroDemandado}
              onChange={(e) => {
                handleDataListCourtChange(
                  e,
                  "designated_arbitrator_defendant_id"
                );
                const filter = designacionArbitroDemandado.filter(
                  (item) => item.value === e.value
                );
                setSelectedDesignacionArbitro({
                  ...selectedDesignacionArbitro,
                  designated_arbitrator_defendant_id: filter,
                });
              }}
            />
            <DataList
              textLabel={"Árbitro parte demandada"}
              name={"arbitrator_defendant_id"}
              className="w-3/4"
              value={selectedDesignacionArbitro.arbitrator_defendant_id}
              dataOptions={arbitros}
              onChange={(e) => {
                handleDataListCourtChange(e, "arbitrator_defendant_id");
                const filter = arbitros.filter(
                  (item) => item.value === e.value
                );
                setSelectedDesignacionArbitro({
                  ...selectedDesignacionArbitro,
                  arbitrator_defendant_id: filter,
                });
              }}
            />
          </div>
        )}
        <h4 className="text-lg text-zinc-600/80 font-normal uppercase mb-1 mt-4">
          Derechos arbitrales de la demanda
        </h4>
        <button
          type="button"
          className="bg-primary px-2 py-1 text-xs text-white font-light"
          onClick={() => setIsModalOpen(true)}
        >
          Agregar
        </button>
        <div className="grid grid-cols-5 gap-x-4 gap-y-2 mt-4 mb-1 items-start border-b border-zinc-200 text-center">
          <label className="text-xs">Monto</label>
          <div className="col-span-2 text-center">
            Tasa administrativa
            <div className="grid grid-cols-2">
              <label className="text-xs">100%</label>
              <label className="text-xs">50%</label>
            </div>
          </div>
          <div className="col-span-2 text-center">
            Honorarios
            <div className="grid grid-cols-2">
              <label className="text-xs">100%</label>
              <label className="text-xs">50%</label>
            </div>
          </div>
          {/* <label className='text-xs'>Parciales</label>
                    <label className='text-xs'>Fecha</label> */}
        </div>
        <div className="grid grid-cols-5 gap-x-4 gap-y-2 mt-1 items-start font-light text-center">
          <label className="text-xs">{formData.amount || 0}</label>
          <label className="text-xs">{resultCourt.resAdmin || 0}</label>
          <label className="text-xs">
            {+resultCourt.resAdmin !== 0 ? +resultCourt.resAdmin / 2 : 0}
          </label>
          <label className="text-xs">{resultCourt.resHonorarios || 0}</label>
          <label className="text-xs">
            {+resultCourt.resHonorarios !== 0
              ? +resultCourt.resHonorarios / 2
              : 0}
          </label>
          {/* <label className='text-xs'>Parciales</label>
                    <label className='text-xs'>Fecha</label> */}
        </div>
        <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-start">
          <Input
            textLabel={"Tasa de presentación"}
            typeInput={"text"}
            name={"presentation"}
            className="w-3/4"
            value={formData.presentation || ""}
            onChange={handleInputChange}
            placeholder="0.00"
          />
          <Input
            textLabel={"Pagos parciales"}
            typeInput={"text"}
            name={"partial_payments"}
            className="w-3/4"
            value={formData.partial_payments || ""}
            onChange={handleInputChange}
            placeholder="0.00"
          />
        </div>
        <h4 className="text-lg text-zinc-600/80 font-normal uppercase mb-1 mt-4">
          Resumen proceso
        </h4>
        <div className="grid grid-cols-1 gap-x-10 gap-y-2 mt-4 items-start">
          <textarea
            className="w-full appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal"
            name="summary"
            rows={3}
            value={formData.summary || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="flex justify-between items-center gap-2 mt-6">
          <div className="flex flex-col gap-2">
            <span className="text-red-500 text-xs italic">
              * Campos obligatorios
            </span>
          </div>
          <div className="flex gap-2 items-center">
            <ButtonPrimaryForm text={"Guardar"} typeBtn={"submit"}>
              <IconSave className="w-4" />
            </ButtonPrimaryForm>
          </div>
        </div>
      </form>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isModal={false}
        title={"Calcular derechos arbitrales"}
        modalSize={"md"}
      >
        <div className="grid grid-cols-3 gap-x-3 gap-y-2 mt-4 items-center">
          <div className="col-span-2">
            <Input
              textLabel={"Monto"}
              typeInput={"text"}
              name={"amount"}
              className="w-3/4"
              value={formData.amount || ""}
              onChange={(e) => {
                const { name, value } = e.target;
                setFormData({
                  ...formData,
                  [name]: +value,
                });
              }}
              placeholder="0.00"
            />
          </div>
          <button
            type="button"
            className="bg-primary px-2 py-1 text-sm text-white font-light"
            onClick={() => {
              const formDataPay = new FormData();
              formDataPay.append("monto", formData.amount);
              fetch("https://arbitrajeccia.com.pe/sistema/web/calcular", {
                method: "POST",
                body: formDataPay,
              })
                .then((response) => response.json())
                .then((data) => {
                  // console.log(data)
                  setFormData({
                    ...formData,
                    arbitration_payments: [
                      {
                        title: "Tasa administrativa",
                        resultado: data.admin.resultado,
                        igv: data.admin.igv,
                      },
                      {
                        title: "Honorarios - Árbitro único",
                        resultado: data.trib.resultado,
                        igv: data.trib.igv,
                      },
                      {
                        title: "Honorarios - Tribunal arbitral",
                        resultado: data.arb.resultado,
                        igv: data.arb.igv,
                      },
                    ],
                  });
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            }}
          >
            Calcular
          </button>
        </div>
        <h4 className="my-3 text-sm font-light">Resultados:</h4>
        {formData.arbitration_payments &&
          formData.arbitration_payments.map((payment, index) => (
            <div key={index} className="border-b border-zinc-200">
              <div className="flex items-center justify-between">
                <p>{payment.title}:</p>
                <p>{payment.resultado}</p>
              </div>
              <div className="flex items-center justify-between">
                <p>IGV:</p> <p>{payment.igv}</p>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-center gap-2 mt-6">
          <div className="flex flex-col gap-2"></div>
          <div className="flex gap-2 items-center">
            <ButtonPrimaryForm text={"Guardar"} typeBtn={"submit"}>
              <IconSave className="w-4" />
            </ButtonPrimaryForm>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ProcessForm;
